// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".access_details[data-v-1c1f3fc1]{padding-left:40px;margin-bottom:20px}.details[data-v-1c1f3fc1]{background-color:var(--el-color-info-light-9);padding:10px 20px 20px 20px}.node_text[data-v-1c1f3fc1]{margin-right:10px;min-width:150px}", ""]);
// Exports
module.exports = exports;
